import React, { useState } from "react";

// 3rd Party library
import PropTypes from "prop-types";

// Styles
import styles from "./style.module.scss";

const ProgressBar = ({ data }) => {
  const [tooltip, setTooltip] = useState({
    text: "",
    visible: false,
    top: 0,
    left: 0,
  });

  const handleMouseMove = (e, label, value) => {
    const tooltipWidth = 100; // Approximate width of the tooltip
    const tooltipHeight = 30; // Approximate height of the tooltip
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    let newLeft = e.clientX + 10; // Default position (right of cursor)
    let newTop = e.clientY + 15; // Default position (below cursor)

    // If tooltip is too close to the right edge, move it to the left of the cursor
    if (newLeft + tooltipWidth > screenWidth) {
      newLeft = e.clientX - tooltipWidth - 10;
    }

    // If tooltip is too close to the bottom, move it above the cursor
    if (newTop + tooltipHeight > screenHeight) {
      newTop = e.clientY - tooltipHeight - 10;
    }

    setTooltip({
      text: `${label}: ${value}%`,
      visible: true,
      top: newTop,
      left: newLeft,
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ ...tooltip, visible: false });
  };

  return (
    <div className={styles["progress-container"]}>
      {data?.labels?.map((label, index) => (
        <div
          key={index}
          className={styles["progress-bar-custom"]}
          style={{
            backgroundColor: data.backgroundColor[index],
            width: data.values[index] + "%",
          }}
          onMouseMove={(e) => handleMouseMove(e, label, data.values[index])}
          onMouseLeave={handleMouseLeave}
        />
      ))}

      {/* Tooltip */}
      {tooltip.visible && (
        <div
          className="tooltip-dynamic"
          style={{
            position: "fixed",
            top: tooltip.top,
            left: tooltip.left,
            backgroundColor: "black",
            color: "white",
            padding: "5px 8px",
            borderRadius: "5px",
            fontSize: "12px",
            pointerEvents: "none",
            whiteSpace: "nowrap",
            zIndex: 9999, // Ensure it appears above other elements
          }}
        >
          {tooltip.text}
        </div>
      )}
    </div>
  );
};

export default React.memo(ProgressBar);

ProgressBar.propTypes = {
  data: PropTypes.array,
};



